import { combineReducers } from "redux";
import { tokenReducer } from "./token";
import { preloadReducer } from "./preload";
import { userReducer } from "./user";
import { loadReducer } from "./load";
import { reimbursementsReducer } from "./reimbursements";
import { transactionsReducer } from "./transactions";
import { organizationReducer } from "./organization";
import { unauthenticatedReducer } from "./unauthenticated/";

const rootReducer = (state, action) => {
  const appReducer = combineReducers({
    token: tokenReducer,
    preload: preloadReducer,
    load: loadReducer,
    unauthenticated: unauthenticatedReducer,
    user: userReducer,
    organization: organizationReducer,
    reimbursements: reimbursementsReducer,
    transactions: transactionsReducer
  });
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./frontend/src/actions/index.js